import styled from 'styled-components';

export const VideoStyle = styled.section`
  width: 100%;
  height: 100%;

  @media (min-width: 1024px) {
    width: 33.8vw;
  }

  .video {
    max-width: 650px;
    width: 90%;
    height: 100%;
    max-width: 550px;
    align-self: center;

    @media (min-width: 1024px) {
      display: none;
    }
  }

  .formVideo__wrapper {
    margin-top: 26px;

    @media (max-width: 1024px) {
      margin-top: 10px;
    }
    .container {
      overflow-y: auto;
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 30px;

      @media (max-width: 1023px) {
        display: flex;
        gap: 10px;
        height: 80vh;
        justify-content: flex-start;
      }

      @media (max-width: 991px) {
        display: flex;
        gap: 10px;
      }

      @media (max-width: 767px) {
        display: flex;
        gap: 10px;
      }
      @media (max-width: 440px) {
        display: flex;
        gap: 10px;
      }

      .title-end {
        color: white;
      }

      .logo-form {
        display: flex;
        justify-content: center;
        gap: 10px;

        @media (max-width: 1023px) {
          margin-top: 10px;
        }

        .logo {
          max-width: 340px;
          height: 100%;

          @media (max-width: 1023px) {
            max-width: 280px;
            padding-bottom: 10px;
          }
        }

        .logo-pride {
          max-height: 50px !important;
        }

        .logo-bradesco {
          position: relative;
          bottom: 25px;
        }
      }

      .title__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        .title {
          text-align: center;
          color: white;
          font-size: 16px;
        }

        .question__wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          .text {
            color: white;
            text-align: center;
            cursor: pointer;
          }

          .arrow {
            transition: transform 0.3s ease;
          }

          .arrow.up {
            transform: rotateX(180deg);
          }

          .dropdown-content {
            background-color: white;
            padding: 10px;
            width: 200px;
            border-radius: 10px;
            font-size: 14px;
            text-align: center;
            max-height: 0;
            opacity: 0;
            visibility: hidden;
            overflow: hidden;
            transition: opacity 0.3s ease, visibility 0s linear 0.3s,
              max-height 0.3s ease;
            position: fixed;
            margin-top: 30px;
            box-shadow: 0px 0px 10px #c1c1c1;
          }

          .dropdown-content.open {
            opacity: 1;
            visibility: visible;
            max-height: 500px; /* Ajuste conforme necessário, ou mantenha generoso */
            transition-delay: 0s;
            user-select: none;
          }
        }
      }

      .buttons__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 30px;
        .button_link {
          text-decoration: none;
          padding: 7px 13px;
          background-color: white;
          border-radius: 26px;
          display: flex;
          align-items: center;
          transition: all 0.5s ease;
          cursor: pointer;
          width: 230px;
          justify-content: center;
          .button_text {
            color: black;
            padding: 0;
            margin: 0;
            font-weight: 700;
            transition: all 0.5s ease;
          }

          &:hover {
            background-color: black;

            .button_text {
              color: white;
            }
          }
        }
      }
    }

    .container::-webkit-scrollbar {
      width: 8px; /* largura da barra de rolagem */
      position: relative;
      right: 5%;
    }

    .container::-webkit-scrollbar-track {
      background-color: transparent !important; /* cor do fundo da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb {
      border-radius: 16px;
      background: #bbb; /* cor da alça da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb:hover {
      background: #555; /* cor da alça da barra de rolagem ao passar o mouse */
    }
  }
`;

export const ParticipantsStyle = styled.section`
  width: 33.8vw;
  height: 100%;

  @media (max-width: 1024px) {
    width: 100%;
  }

  .formParticipants__wrapper {
    .container {
      overflow-y: auto;
      height: 85vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 30px;

      @media (max-width: 1023px) {
        height: 80vh;
      }

      .logo-form {
        display: flex;
        justify-content: center;
        gap: 10px;

        .logo {
          max-width: 340px;
          height: 100%;

          @media (max-width: 1023px) {
            max-width: 280px;
            padding-bottom: 10px;
          }
        }

        .logo-pride {
          max-height: 50px !important;
        }

        .logo-bradesco {
          position: relative;
          bottom: 25px;
        }
      }

      .title__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        .title {
          color: white;
          text-align: center;
          font-size: 16px;

          @media (max-width: 768px) {
            text-align: center;
            font-size: 16px;
          }
        }

        .question__wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          .text {
            color: white;
            text-align: center;
            cursor: pointer;
          }

          .arrow {
            transition: transform 0.3s ease;
          }

          .arrow.up {
            transform: rotateX(180deg);
          }

          .dropdown-content {
            background-color: white;
            padding: 10px;
            width: 200px;
            border-radius: 10px;
            font-size: 14px;
            text-align: center;
            max-height: 0;
            opacity: 0;
            visibility: hidden;
            overflow: hidden;
            transition: opacity 0.3s ease, visibility 0s linear 0.3s,
              max-height 0.3s ease;
            position: fixed;
            margin-top: 30px;
            box-shadow: 0px 0px 10px #c1c1c1;
          }

          .dropdown-content.open {
            opacity: 1;
            visibility: visible;
            max-height: 500px; /* Ajuste conforme necessário, ou mantenha generoso */
            transition-delay: 0s;
            user-select: none;
          }
        }
      }

      .buttons__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 14px;
        .button_link {
          text-decoration: none;
          padding: 7px 13px;
          background-color: white;
          border-radius: 26px;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.5s ease;
          width: 180px;
          .button_text {
            color: black;
            padding: 0;
            margin: 0;
            font-weight: 700;
            transition: all 0.5s ease;
          }

          &:hover {
            background-color: black;

            .button_text {
              color: white;
            }
          }
        }
      }
    }

    .container::-webkit-scrollbar {
      width: 8px; /* largura da barra de rolagem */
      position: relative;
      right: 5%;
    }

    .container::-webkit-scrollbar-track {
      background-color: transparent !important; /* cor do fundo da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb {
      border-radius: 16px;
      background: #bbb; /* cor da alça da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb:hover {
      background: #555; /* cor da alça da barra de rolagem ao passar o mouse */
    }
  }
`;

export const AgeStyle = styled.section`
  font-family: 'Montserrat';
  height: 100%;
  color: white;
  width: 33.8vw;

  @media (max-width: 1023px) {
    width: 100%;
  }

  .logo-wrapper {
    display: flex;
    justify-content: center;
    gap: 10px;

    .logo-img {
      max-width: 340px;
      height: 100%;

      @media (max-width: 1023px) {
        max-width: 300px;
        padding-bottom: 10px;
      }
    }

    .logo-pride {
      max-height: 50px !important;
    }

    .logo-bradesco {
      position: relative;
      bottom: 25px;
    }
  }

  .formAge {
    max-width: 100%;
    margin: 0 auto;
    height: 85vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow-y: scroll;

    @media (max-width: 1023px) {
      justify-content: center;
      height: 85vh;
    }

    .formAge_title__container {
      text-align: left;
      display: flex;
      flex-direction: column;
      align-items: center;

      .formAge_title {
        padding-top: 10%;
        font-size: 16px;
        font-weight: 600;
        text-align: center;

        @media (max-width: 1024px) {
          padding-top: 1%;
          text-align: center;
        }
      }

      .question__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        .text {
          color: white;
          text-align: center;
          cursor: pointer;
        }

        .arrow {
          transition: transform 0.3s ease;
        }

        .arrow.up {
          transform: rotateX(180deg);
        }

        .dropdown-content {
          color: black;
          background-color: white;
          padding: 10px;
          width: 200px;
          border-radius: 10px;
          font-size: 14px;
          text-align: center;
          max-height: 0;
          opacity: 0;
          visibility: hidden;
          overflow: hidden;
          transition: opacity 0.3s ease, visibility 0s linear 0.3s,
            max-height 0.3s ease;
          position: fixed;
          margin-top: 30px;
          box-shadow: 0px 0px 10px #c1c1c1;
        }

        .dropdown-content.open {
          opacity: 1;
          visibility: visible;
          max-height: 500px; /* Ajuste conforme necessário, ou mantenha generoso */
          transition-delay: 0s;
          user-select: none;
        }
      }
    }

    .bold {
      font-weight: 700;
    }

    .formAge_fields__container {
      display: flex;
      justify-content: space-around;
      margin: 20px 0;
      gap: 50px;
      text-align: center;

      @media (max-width: 1080px) {
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
      }

      @media (max-width: 768px) {
        gap: 10px;
        margin-top: 0;
      }

      .formAge_table__container {
        font-family: Montserrat;
        max-width: 400px;

        .btnAges {
          color: black;
          border: none;
          width: 10px;
          height: 17px;
          font-size: 27px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        h2 {
        }

        table {
          background-color: #eee;
          border: 0px solid transparent;
          border-radius: 10px;

          tbody {
            border-top: 0px solid transparent;
            display: grid;
            grid-template-columns: 50% 50%;
            justify-items: center;
            align-items: center;
            padding: 10px;
            column-gap: 10px;
            justify-content: center;
            width: 300px;

            th {
              width: 80px;
            }

            td {
              padding: 0.2rem 0.5rem;
            }
          }
        }
      }
    }

    .formAge_table__container {
      display: flex;
      flex-direction: column;
      gap: 5px;

      .d-flex {
        align-items: center;
      }

      .field_label {
        margin: 0 !important;
        display: flex;
        align-items: flex-end;
        letter-spacing: 1px;
        font-weight: 600;

        @media (max-width: 768px) {
          font-size: 8px;
        }
      }

      .form-control {
        border: none;
        border-radius: 0;
        width: 50px;
        background-color: transparent;
        padding: 0;
        border-bottom: 1px solid;

        @media (max-width: 768px) {
          font-size: 14px;
        }
      }
    }
  }

  .formAge_additionalFields__container {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .employees_field {
      display: flex;

      .employees_label {
        margin: 0 !important;
        display: flex;
        align-items: flex-end;
      }

      .employees_input {
        .form-control {
          background-color: transparent;
          border: none;
          border-radius: 0;
          border-bottom: 1px solid var(--yellow-pride);
          width: 150px;
          margin-left: 10px;
        }
      }
    }
  }

  .formAge::-webkit-scrollbar {
    width: 8px; /* largura da barra de rolagem */
    position: relative;
    right: 5%;
  }

  .formAge::-webkit-scrollbar-track {
    background-color: transparent !important; /* cor do fundo da barra de rolagem */
  }

  .formAge::-webkit-scrollbar-thumb {
    border-radius: 16px;
    background: #bbb; /* cor da alça da barra de rolagem */
  }

  .formAge::-webkit-scrollbar-thumb:hover {
    background: #555; /* cor da alça da barra de rolagem ao passar o mouse */
  }
`;

export const PreferencesStyle = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @media (min-width: 1024px) {
    height: 100vh;
    width: 33.8vw;
  }

  .preferences__wrapper {
    .logo-form {
      display: flex;
      justify-content: center;
      gap: 10px;

      .logo {
        max-width: 340px;
        height: 100%;

        @media (max-width: 1023px) {
          max-width: 300px;
          padding-bottom: 10px;
        }
      }

      .logo-pride {
        max-height: 50px !important;
      }

      .logo-bradesco {
        position: relative;
        bottom: 25px;
      }
    }

    .container {
      overflow-y: auto;
      overflow-x: hidden;
      height: 85vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 30px;
      padding-top: 0;

      @media (max-width: 1023px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 80vh;
      }

      @media (max-width: 650px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 80vh;
      }

      @media (max-width: 500px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 80vh;
      }

      .content__wrapper {
        text-align: center;
        .title {
          color: white;
          font-size: 16px;
        }

        .question__wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          .text {
            color: white;
            text-align: center;
            cursor: pointer;
          }

          .arrow {
            transition: transform 0.3s ease;
          }

          .arrow.up {
            transform: rotateX(180deg);
          }

          .dropdown-content {
            background-color: white;
            padding: 10px;
            width: 200px;
            border-radius: 10px;
            font-size: 14px;
            text-align: center;
            max-height: 0;
            opacity: 0;
            visibility: hidden;
            overflow: hidden;
            transition: opacity 0.3s ease, visibility 0s linear 0.3s,
              max-height 0.3s ease;
            position: fixed;
            margin-top: 30px;
            box-shadow: 0px 0px 10px #c1c1c1;
          }

          .dropdown-content.open {
            opacity: 1;
            visibility: visible;
            max-height: 500px; /* Ajuste conforme necessário, ou mantenha generoso */
            transition-delay: 0s;
            user-select: none;
          }
        }
      }

      .inputs__wrapper {
        color: white;
        display: flex;
        flex-direction: column;
        gap: 20px;
        text-align: left;
        align-items: center;

        .input_container {
          width: 380px;

          @media (max-width: 1023px) {
            width: auto;
          }
        }

        .form-label {
          font-size: 14px;
          margin-left: 10px;
        }

        .form-control {
          min-height: calc(1.5em + 0.75rem + 50px);

          @media (max-width: 1023px) {
            width: 80vw;
          }
        }

        .no-resize {
          resize: none;
        }
      }
    }

    .container::-webkit-scrollbar {
      width: 8px; /* largura da barra de rolagem */
      position: relative;
      right: 5%;
    }

    .container::-webkit-scrollbar-track {
      background-color: transparent !important; /* cor do fundo da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb {
      border-radius: 16px;
      background: #bbb; /* cor da alça da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb:hover {
      background: #555; /* cor da alça da barra de rolagem ao passar o mouse */
    }

    .footer-note {
      color: white;
      position: absolute;
      bottom: 15%;
      width: 32%;
      text-align: center;
      align-self: center;

      @media (max-width: 1023px) {
        position: fixed;
        width: 88% !important;
      }
    }
  }
`;

export const BasicStyle = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @media (min-width: 1024px) {
    height: 100vh;
    width: 33.8vw;
  }

  .basic__wrapper {
    .logo-form {
      display: flex;
      justify-content: center;
      gap: 10px;

      @media (max-width: 1023px) {
        margin: 0;
      }
      .logo {
        max-width: 340px;
        height: 100%;

        @media (max-width: 1023px) {
          max-width: 300px;
          padding-bottom: 10px;
        }
      }

      .logo-pride {
        max-height: 50px !important;
      }

      .logo-bradesco {
        position: relative;
        bottom: 25px;
      }
    }

    .container {
      overflow-y: auto;
      overflow-x: hidden;
      height: 85vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 20px;

      @media (max-width: 1023px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 80vh;
      }

      @media (max-width: 650px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 80vh;
      }

      @media (max-width: 500px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 80vh;
      }

      @media (max-width: 400px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 80vh;
      }

      .content__wrapper {
        text-align: center;
        .title {
          color: white;
          font-size: 16px;
        }

        .question__wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          .text {
            color: white;
            text-align: center;
            cursor: pointer;
          }

          .arrow {
            transition: transform 0.3s ease;
          }

          .arrow.up {
            transform: rotateX(180deg);
          }

          .dropdown-content {
            background-color: white;
            padding: 10px;
            width: 200px;
            border-radius: 10px;
            font-size: 14px;
            text-align: center;
            max-height: 0;
            opacity: 0;
            visibility: hidden;
            overflow: hidden;
            transition: opacity 0.3s ease, visibility 0s linear 0.3s,
              max-height 0.3s ease;
            position: fixed;
            margin-top: 30px;
            box-shadow: 0px 0px 10px #c1c1c1;
          }

          .dropdown-content.open {
            opacity: 1;
            visibility: visible;
            max-height: 500px; /* Ajuste conforme necessário, ou mantenha generoso */
            transition-delay: 0s;
            user-select: none;
          }
        }
      }

      .inputs__wrapper {
        color: white;
        display: flex;
        flex-direction: column;
        gap: 20px;
        text-align: left;
        align-items: center;

        .input_container {
          width: 380px;

          @media (max-width: 1023px) {
            width: auto;
          }

          .form-control::-webkit-inner-spin-button {
            display: none;
          }
        }

        .form-label {
          font-size: 14px;
          margin-left: 10px;
        }
      }
    }

    .container::-webkit-scrollbar {
      width: 8px; /* largura da barra de rolagem */
      position: relative;
      right: 5%;
    }

    .container::-webkit-scrollbar-track {
      background-color: transparent !important; /* cor do fundo da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb {
      border-radius: 16px;
      background: #bbb; /* cor da alça da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb:hover {
      background: #555; /* cor da alça da barra de rolagem ao passar o mouse */
    }
  }
`;

export const CurrentPlanStyle = styled.section`
  width: 100%;

  @media (min-width: 1024px) {
    width: 33.8vw;
  }

  .currentPlan__wrapper {
    margin-top: 26px;
    .container {
      overflow-y: auto;
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 30px;

      @media (max-width: 1023px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 85vh;
        gap: 10px;
      }

      @media (max-width: 991px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 85vh;
        gap: 10px;
      }

      @media (max-width: 767px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 85vh;
        gap: 10px;
      }
      @media (max-width: 440px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 85vh;
        gap: 10px;
      }

      .title-end {
        color: white;
      }

      .logo-form {
        display: flex;
        justify-content: center;
        gap: 10px;

        @media (max-width: 1023px) {
          margin: 0;
        }
        .logo {
          max-width: 340px;
          height: 100%;

          @media (max-width: 1023px) {
            max-width: 280px;
            padding-bottom: 10px;
          }
        }
        .logo-pride {
          max-height: 50px !important;
        }
        .logo-bradesco {
          position: relative;
          bottom: 25px;
        }
      }

      .title__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        .title {
          text-align: center;
          color: white;
          font-size: 16px;
        }

        .question__wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          .text {
            color: white;
            text-align: center;
            cursor: pointer;
          }

          .arrow {
            transition: transform 0.3s ease;
          }

          .arrow.up {
            transform: rotateX(180deg);
          }

          .dropdown-content {
            background-color: white;
            padding: 10px;
            width: 200px;
            border-radius: 10px;
            font-size: 14px;
            text-align: center;
            max-height: 0;
            opacity: 0;
            visibility: hidden;
            overflow: hidden;
            transition: opacity 0.3s ease, visibility 0s linear 0.3s,
              max-height 0.3s ease;
            position: fixed;
            margin-top: 30px;
            box-shadow: 0px 0px 10px #c1c1c1;
          }

          .dropdown-content.open {
            opacity: 1;
            visibility: visible;
            max-height: 500px; /* Ajuste conforme necessário, ou mantenha generoso */
            transition-delay: 0s;
            user-select: none;
          }
        }
      }

      .buttons__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 30px;

        .operatorQuestion {
          display: flex;
          flex-direction: column;
          width: 100%;

          .questionLabel {
            color: white;
            text-align: center;
          }

          .questionInput {
            border: none;
            border-radius: 10px;
            height: 40px;
            width: 80%;
            margin: 0 auto;
            text-align: center;
          }
        }

        .button_link {
          text-decoration: none;
          padding: 7px 13px;
          background-color: white;
          border-radius: 26px;
          border: none;
          display: flex;
          align-items: center;
          transition: all 0.5s ease;
          cursor: pointer;
          width: 225px;
          justify-content: center;
          font-weight: 700;
          .button_text {
            color: black;
            padding: 0;
            margin: 0;
            font-weight: 700;
            transition: all 0.5s ease;
          }

          &:hover {
            background-color: black;
            color: white;

            .button_text {
              color: white;
            }
          }
        }
        .selected {
          background-color: #000;
          color: white; /* Cor de fundo para botão selecionado */
          .button_text {
            color: #fff; /* Cor do texto para botão selecionado */
          }
        }

        .sendButton {
          padding: 10px;
          width: 200px;
          font-weight: 700;
          border: none;
          border-radius: 26px;
          margin-top: 50px;
        }
      }
    }

    .container::-webkit-scrollbar {
      width: 8px; /* largura da barra de rolagem */
      position: relative;
      right: 5%;
    }

    .container::-webkit-scrollbar-track {
      background-color: transparent !important; /* cor do fundo da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb {
      border-radius: 16px;
      background: #bbb; /* cor da alça da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb:hover {
      background: #555; /* cor da alça da barra de rolagem ao passar o mouse */
    }
  }
`;

export const ChoicesStyle = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @media (min-width: 1024px) {
    height: 100vh;
    width: 33.8vw;
  }
  .choices__wrapper {
    .logo-form {
      display: flex;
      justify-content: center;
      margin: 30px 0 20px;

      .logo {
        max-width: 340px;
        height: 100%;
      }
    }

    .container {
      overflow-y: auto;
      height: 80vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 10px;

      @media (max-width: 1023px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 80vh;
      }

      @media (max-width: 650px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 80vh;
      }

      @media (max-width: 500px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 80vh;
      }
      .content__wrapper {
        text-align: center;
        .title {
          color: white;
          font-size: 16px;
        }

        .question__wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          .text {
            color: white;
            text-align: center;
            cursor: pointer;
          }

          .arrow {
            transition: transform 0.3s ease;
          }

          .arrow.up {
            transform: rotateX(180deg);
          }

          .dropdown-content {
            background-color: white;
            padding: 10px;
            width: 200px;
            border-radius: 10px;
            font-size: 14px;
            text-align: center;
            max-height: 0;
            opacity: 0;
            visibility: hidden;
            overflow: hidden;
            transition: opacity 0.3s ease, visibility 0s linear 0.3s,
              max-height 0.3s ease;
            position: fixed;
            margin-top: 30px;
            box-shadow: 0px 0px 10px #c1c1c1;
          }

          .dropdown-content.open {
            opacity: 1;
            visibility: visible;
            max-height: 500px; /* Ajuste conforme necessário, ou mantenha generoso */
            transition-delay: 0s;
            user-select: none;
          }
        }
      }

      #operatorsChoice {
      }

      .selectedChoices {
        .selectedChoice {
          color: white;
          .button-close {
            color: red;
            border: none;
            background-color: transparent;
          }
        }
      }
    }

    .container::-webkit-scrollbar {
      width: 8px; /* largura da barra de rolagem */
      position: relative;
      right: 5%;
    }

    .container::-webkit-scrollbar-track {
      background-color: transparent !important; /* cor do fundo da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb {
      border-radius: 16px;
      background: #bbb; /* cor da alça da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb:hover {
      background: #555; /* cor da alça da barra de rolagem ao passar o mouse */
    }
  }
`;

export const UrgencyStyle = styled.section`
  width: 33.8vw;
  height: 100%;

  @media (max-width: 1024px) {
    width: 100%;
  }

  .formUrgency__wrapper {
    .container {
      overflow-y: auto;
      height: 85vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 30px;

      @media (max-width: 1023px) {
        height: 80vh;
        justify-content: center;
      }

      .logo-form {
        display: flex;
        justify-content: center;
        gap: 10px;

        @media (max-width: 1023px) {
          margin: 0;
        }
        .logo {
          max-width: 340px;
          height: 100%;

          @media (max-width: 1023px) {
            max-width: 280px;
            padding-bottom: 10px;
          }
        }
        .logo-pride {
          max-height: 50px !important;
        }
        .logo-bradesco {
          position: relative;
          bottom: 25px;
        }
      }

      .title__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        .title {
          color: white;
          text-align: center;
          font-size: 16px;

          @media (max-width: 768px) {
            text-align: center;
            font-size: 16px;
          }
        }

        .question__wrapper {
          .text {
            color: white;
            text-align: center;
            cursor: pointer;
          }

          .arrow {
            transition: transform 0.3s ease;
          }

          .arrow.up {
            transform: rotateX(180deg);
          }

          .dropdown-content {
            background-color: white;
            padding: 10px;
            width: 200px;
            border-radius: 10px;
            font-size: 14px;
            text-align: center;
            max-height: 0;
            opacity: 0;
            visibility: hidden;
            overflow: hidden;
            transition: opacity 0.3s ease, visibility 0s linear 0.3s,
              max-height 0.3s ease;
            position: fixed;
            box-shadow: 0px 0px 10px #c1c1c1;
          }

          .dropdown-content.open {
            opacity: 1;
            visibility: visible;
            max-height: 500px; /* Ajuste conforme necessário, ou mantenha generoso */
            transition-delay: 0s;
            user-select: none;
          }
        }
      }

      .buttons__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 14px;
        .button_link {
          text-decoration: none;
          padding: 7px 13px;
          background-color: white;
          border-radius: 26px;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.5s ease;
          width: 200px;
          cursor: pointer;
          .button_text {
            color: black;
            padding: 0;
            margin: 0;
            font-weight: 700;
            transition: all 0.5s ease;
          }

          &:hover {
            background-color: black;

            .button_text {
              color: white;
            }
          }
        }
      }
    }

    .container::-webkit-scrollbar {
      width: 8px; /* largura da barra de rolagem */
      position: relative;
      right: 5%;
    }

    .container::-webkit-scrollbar-track {
      background-color: transparent !important; /* cor do fundo da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb {
      border-radius: 16px;
      background: #bbb; /* cor da alça da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb:hover {
      background: #555; /* cor da alça da barra de rolagem ao passar o mouse */
    }
  }
`;

export const ContactStyle = styled.section`
  width: 33.8vw;
  height: 100%;

  @media (max-width: 1024px) {
    width: 100%;
  }

  .footer-text {
    color: white;
    position: absolute;
    bottom: 15%;
    text-align: center;
  }

  .formContact__wrapper {
    .container {
      overflow-y: auto;
      height: 85vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 30px;

      @media (max-width: 1023px) {
        height: 80vh;
        justify-content: center;
      }

      .logo-form {
        display: flex;
        justify-content: center;
        gap: 10px;

        @media (max-width: 1023px) {
          margin: 0;
        }
        .logo {
          max-width: 340px;
          height: 100%;

          @media (max-width: 1023px) {
            max-width: 280px;
            padding-bottom: 10px;
          }
        }
        .logo-pride {
          max-height: 50px !important;
        }
        .logo-bradesco {
          position: relative;
          bottom: 25px;
        }
      }

      .title__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        .title {
          color: white;
          text-align: center;
          font-size: 16px;

          @media (max-width: 768px) {
            text-align: center;
            font-size: 16px;
          }
        }

        .question__wrapper {
          .text {
            color: white;
            text-align: center;
            cursor: pointer;
          }

          .arrow {
            transition: transform 0.3s ease;
          }

          .arrow.up {
            transform: rotateX(180deg);
          }

          .dropdown-content {
            background-color: white;
            padding: 10px;
            width: 200px;
            border-radius: 10px;
            font-size: 14px;
            text-align: center;
            max-height: 0;
            opacity: 0;
            visibility: hidden;
            overflow: hidden;
            transition: opacity 0.3s ease, visibility 0s linear 0.3s,
              max-height 0.3s ease;
            position: fixed;
            box-shadow: 0px 0px 10px #c1c1c1;
          }

          .dropdown-content.open {
            opacity: 1;
            visibility: visible;
            max-height: 500px; /* Ajuste conforme necessário, ou mantenha generoso */
            transition-delay: 0s;
            user-select: none;
          }
        }
      }

      .buttons__wrapper {
        display: flex;
        align-items: center;
        gap: 14px;
        .button_link {
          text-decoration: none;
          padding: 7px 13px;
          background-color: white;
          border-radius: 26px;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.5s ease;
          width: 150px;
          cursor: pointer;
          .button_text {
            color: black;
            padding: 0;
            margin: 0;
            font-weight: 700;
            transition: all 0.5s ease;
          }

          &.selected {
            background-color: #ca991e;
            color: white;
            font-weight: bold;
          }

          &:hover {
            background-color: black;
            color: white;

            .button_text {
              color: white;
            }
          }
        }
      }
    }

    .input__wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;

      .inputLabel {
        color: white;
        text-align: center;
      }

      .returnTime {
        width: 140px;
        text-align: center;
        padding: 7px 10px;
      }

      .callTime {
        width: 200px;
        text-align: center;
        padding: 7px 10px;
      }
    }

    .container::-webkit-scrollbar {
      width: 8px; /* largura da barra de rolagem */
      position: relative;
      right: 5%;
    }

    .container::-webkit-scrollbar-track {
      background-color: transparent !important; /* cor do fundo da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb {
      border-radius: 16px;
      background: #bbb; /* cor da alça da barra de rolagem */
    }

    .container::-webkit-scrollbar-thumb:hover {
      background: #555; /* cor da alça da barra de rolagem ao passar o mouse */
    }
  }
`;

export const EndStyle = styled.section`
  width: 100%;

  @media (min-width: 1024px) {
    width: 33.8vw;
  }

  .formEnd__wrapper {
    .logo-form {
      display: flex;
      justify-content: center;

      .logo {
        max-width: 210px;
        height: 100%;
      }
    }

    .container {
      display: flex;
      flex-direction: column;
      height: 100vh;
      justify-content: center;
      align-items: center;
      text-align: center;
      gap: 20px;

      @media (max-width: 1023px) {
        height: 80vh;
      }

      .title-end {
        color: white;
        font-size: 16px;
      }

      .buttons__wrapper {
        display: flex;
        flex-direction: column;
        gap: 14px;

        .button_link {
          text-decoration: none;
          padding: 7px 13px;
          background-color: white;
          border-radius: 26px;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.5s ease;
          width: 300px;
          cursor: pointer;
          font-weight: 700;
          transition: all 0.5s ease;
          .button_text {
            color: black;
            padding: 0;
            margin: 0;
            font-weight: 700;
          }

          &:hover {
            background-color: black;
            color: white;

            .button_text {
              color: white;
            }
          }
        }
      }
    }

    .img__wrapper {
      width: 100%;
      display: flex;
      justify-content: center;

      img {
        width: 100%;
        max-width: 550px;
      }
    }
  }
`;

export const PlansStyle = styled.section`
  width: 100%;

  .plans__wrapper {
    .container {
      padding-bottom: 30px;
      .title__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .title {
        text-align: center;
        font-weight: 700;
        margin-top: 35px;
        margin-bottom: 20px;
      }

      .stripe {
        background-color: #00022d;
        border-radius: 10px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .content {
          color: white;
          text-align: center;
          font-weight: 700;
        }

        .button {
          background-color: #ca991e;
          padding: 7px 13px;
          width: fit-content;
          display: flex;
          border-radius: 26px;
          text-decoration: none;
          color: white;
          font-weight: 700;
          .button_text {
            margin: 0;
          }
        }
      }

      .mb-3 {
        display: flex;
        justify-content: center;
      }

      #Operators {
        margin-top: 5%;
        margin-bottom: 5%;
        box-shadow: 0 0 30px #00000025;
        width: 300px;
      }

      .plans-container {
        display: flex;
        justify-content: center; /* Centraliza os planos horizontalmente */
        flex-wrap: wrap; /* Permite que os planos passem para a próxima linha se necessário */
        gap: 16px; /* Espaço entre os planos */
      }

      @media (min-width: 1024px) {
        .plan-detail {
          flex: 0 0 calc(33.333% - 16px); /* Define a largura de cada plano para um terço do container menos o gap */
        }
      }

      .shown-operator::-webkit-scrollbar {
        width: 8px; /* largura da barra de rolagem */
        position: relative;
        right: 5%;
      }

      .shown-operator::-webkit-scrollbar-track {
        background-color: transparent !important; /* cor do fundo da barra de rolagem */
      }

      .shown-operator::-webkit-scrollbar-thumb {
        border-radius: 16px;
        background: #bbb; /* cor da alça da barra de rolagem */
      }

      .shown-operator::-webkit-scrollbar-thumb:hover {
        background: #555; /* cor da alça da barra de rolagem ao passar o mouse */
      }

      .amilPlans {
        display: flex !important;
        flex-direction: column;
        gap: 20px;
        align-items: center;

        .logo-img {
          width: 115px;
        }
      }
      .bradescoPlans {
        display: flex !important;
        flex-direction: column;
        gap: 20px;
        align-items: center;

        .logo-img {
          width: 165px;
          height: 65px;
        }
      }
      .ndiPlans {
        display: flex !important;
        flex-direction: column;
        gap: 20px;
        align-items: center;

        .logo-img {
          width: 165px;
          height: 70px;
        }
      }
    }
  }
`;
